module.exports = __webpack_public_path__ + "static/media/tracey-miss.6d14d78a.wav";